<template>
  <div
    class="demo__MobileBanner demo__bg--bgBannerSecondary demo__weight--600 demo__flex demo__flex-between demo__flex-middle"
    v-if="!isHide"
  >
    <div class="demo__MobileBanner--text demo__font--14">
      <slot></slot>
    </div>
    <div class="demo__MobileBanner--icon demo__text-right demo__color--white">
      <i class="fa-light fa-xmark demo__font--22" @click="hide = true"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    id: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      hide: false,
    };
  },
  computed: {
    ...mapGetters(["user"]),
    isHide() {
      return localStorage.getItem("top_banner_demo_" + this.id) || this.hide;
    },
  },
  watch: {
    hide() {
      localStorage.setItem("top_banner_demo_" + this.id, true);
    },
  },
};
</script>
